import { api } from "../../../utils/api"

export const patchOrderBlockLand = async (data) => {
  const id = data.id;
  try {
    const response = await api.patch(`order-block-land/${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error(error);
  }
}
